import { WebStorageStateStore } from 'oidc-client-ts';

const parseEnvBool = (v: unknown, defaultValue: boolean) => {
  if (v === undefined || v === null || v === '') return defaultValue;
  const s = String(v).trim().toLowerCase();
  if (['1', 'true', 'yes', 'y', 'on'].includes(s)) return true;
  if (['0', 'false', 'no', 'n', 'off'].includes(s)) return false;
  return defaultValue;
};

// 开关：true 走单点（OIDC），false 不走（走普通登录）
// - 开发环境默认 false，避免本地调试被强制重定向
// - 其他环境默认 true
// @ts-ignore - Vite 环境变量类型定义
export const isSsoEnabled = parseEnvBool(
  // @ts-ignore
  import.meta.env.VITE_ENABLE_SSO,
  // @ts-ignore
  import.meta.env.NODE_ENV === 'development' ? false : true
);

// @ts-ignore - Vite 环境变量类型定义
const authority = import.meta.env.VITE_APP_OIDC_AUTHORITY;
// @ts-ignore - Vite 环境变量类型定义
const client_id = import.meta.env.VITE_APP_OIDC_CLIENT_ID;
// @ts-ignore - Vite 环境变量类型定义
const client_secret = import.meta.env.VITE_APP_OIDC_CLIENT_SECRET;

// @ts-ignore - Vite 环境变量类型定义
const web_url = import.meta.env.VITE_APP_BASE_URL || window.location.origin;

const oidcConfig = {
  authority: authority,
  client_id: client_id,
  redirect_uri: `${web_url}/callback`,
  post_logout_redirect_uri: `${web_url}/`,
  client_secret: client_secret,
  // 响应类型
  response_type: 'code',  // 推荐使用 Authorization Code Flow with PKCE
  scope: 'api openid profile offline_access',
  
  // 自动管理Token
  // 注意：在回调处理期间，自动刷新可能会与回调流程冲突
  // 通过设置 accessTokenExpiringNotificationTime 来延迟自动刷新的触发时机
  automaticSilentRenew: true,
  silent_redirect_uri: `${web_url}/silent-renew.html`,
  // 设置 token 过期前 60 秒才触发自动刷新，避免在回调时立即触发
  accessTokenExpiringNotificationTime: 60,
  
  // 使用 localStorage 存储登录状态（包括 state、user 等信息）
  // 这样可以避免刷新页面后 state 丢失导致的 "No matching state found in storage" 错误
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  
  // 用户信息
  loadUserInfo: true,
  
  // PKCE配置
  response_mode: 'query',  // 明确指定使用 query 模式
  
  // 其他配置
  filterProtocolClaims: true,
  clockSkew: 30,  // 30秒时钟偏差
  
  // 本地开发特殊配置
  // @ts-ignore - Vite 环境变量类型定义
  extraQueryParams: import.meta.env.NODE_ENV === 'development' 
    ? { 'prompt': 'login' } 
    : undefined,
};
console.log('配置信息11111', oidcConfig);

export default oidcConfig;